module.exports = __webpack_public_path__ + "static/media/3364-e-r.2fba14ed.png";